module.exports = __webpack_public_path__ + "img/p-one-step-13.77c4b943.png";